import React from "react";
import { ProductWarrantyCreateFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Buttons, Inputs } from "components";

const ProductWarrantyCreateForm = ({ permission, onCancel, onSubmit }) => {
  const schema = yup.object().shape({
    SerialNo: yup.string().required("Required"),
    ItemNo: yup.string().required("Required"),
    Description: yup.string().required("Required"),
    DealerCode: yup.string().required("Required"),
    InvoiceNo: yup.string().required("Required"),
    InvoiceType: yup.string().required("Required"),
    InvoiceDate: yup.string().required("Required"),
    WaranteePeriod: yup.string().required("Required"),
    WaranteeUnit: yup.string().required("Required"),
    ExtensionPeriod: yup.string().required("Required"),
    ExtensionUnit: yup.string().required("Required"),
    WaranteeDescriptionTH: yup.string().required("Required"),
    WaranteeDescriptionEN: yup.string().required("Required"),
    PD_Dep_Code: yup.string().required("Required"),
    PD_Dep_Desc: yup.string().required("Required"),
    PD_Cat02_Code: yup.string().required("Required"),
    PD_Cat02_Desc: yup.string().required("Required"),
    PD_Cat03_Code: yup.string().required("Required"),
    PD_Cat03_Desc: yup.string().required("Required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <ProductWarrantyCreateFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"Sn"}
                // placeholder={t('test')}
                errors={errors.SerialNo?.message}
              />
            )}
            name="SerialNo"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"Item no"}
                // placeholder={t('test')}
                errors={errors.ItemNo?.message}
              />
            )}
            name="ItemNo"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"Description"}
                // placeholder={t('test')}
                errors={errors.Description?.message}
              />
            )}
            name="Description"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"Dealer Code"}
                errors={errors.DealerCode?.message}
              />
            )}
            name="DealerCode"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"Dealer Name"}
                errors={errors.DealerName?.message}
              />
            )}
            name="DealerName"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"Invoice no"}
                errors={errors.InvoiceNo?.message}
              />
            )}
            name="InvoiceNo"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"Invoice type"}
                errors={errors.InvoiceType?.message}
              />
            )}
            name="InvoiceType"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.DateTime
                {...field}
                label={"Invoice date"}
                errors={errors.InvoiceDate?.message}
              />
            )}
            name="InvoiceDate"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                type="number"
                label={"Warranty Period"}
                errors={errors.WaranteePeriod?.message}
              />
            )}
            name="WaranteePeriod"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.Dropdown
                {...field}
                options={[
                  { label: "วัน", value: "D" },
                  { label: "เดือน", value: "M" },
                  { label: "ปี", value: "Y" },
                ]}
                label={"Warranty Unit"}
                errors={errors.WaranteeUnit?.message}
              />
            )}
            name="WaranteeUnit"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                type="number"
                label={"Warranty Extension Period"}
                errors={errors.ExtensionPeriod?.message}
              />
            )}
            name="ExtensionPeriod"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.Dropdown
                {...field}
                options={[
                  { label: "วัน", value: "D" },
                  { label: "เดือน", value: "M" },
                  { label: "ปี", value: "Y" },
                ]}
                label={"Warranty Extension Period Unit"}
                errors={errors.ExtensionUnit?.message}
              />
            )}
            name="ExtensionUnit"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"Condition TH"}
                errors={errors.WaranteeDescriptionTH?.message}
              />
            )}
            name="WaranteeDescriptionTH"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"Condition En"}
                errors={errors.WaranteeDescriptionEN?.message}
              />
            )}
            name="WaranteeDescriptionEN"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"PD dep code"}
                errors={errors.PD_Dep_Code?.message}
              />
            )}
            name="PD_Dep_Code"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"PD dep desc"}
                errors={errors.PD_Dep_Desc?.message}
              />
            )}
            name="PD_Dep_Desc"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"PD cat02 code"}
                errors={errors.PD_Cat02_Code?.message}
              />
            )}
            name="PD_Cat02_Code"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"PD cat02 desc"}
                errors={errors.PD_Cat02_Desc?.message}
              />
            )}
            name="PD_Cat02_Desc"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"PD cat03 code"}
                errors={errors.PD_Cat03_Code?.message}
              />
            )}
            name="PD_Cat03_Code"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={"PD cat03 desc"}
                errors={errors.PD_Cat03_Desc?.message}
              />
            )}
            name="PD_Cat03_Desc"
            defaultValue=""
          />
        </div>
        <div className="action_row">
          <div className="w120">
            <Buttons.BgStandard theme_gray label="Back" onClick={onCancel} />
          </div>
          {permission.is_create && (
            <div className="w120">
              <Buttons.BgStandard
                type="submit"
                label="Save"
                // disabled={initialValues && initialValues.is_center}
              />
            </div>
          )}
        </div>
      </form>
    </ProductWarrantyCreateFormStyled>
  );
};

ProductWarrantyCreateForm.propTypes = {};

export default ProductWarrantyCreateForm;
